import { useStore } from 'vuex';
import Events from '../../../shared/settings/events';

export default function useLinkAction() {
	const store = useStore();

	async function addSampleAction(variant) {
		const response = await store.dispatch('addItemToBasket', variant);

		if (response.status === 200) {
			const openFlyoutBasket = new CustomEvent(Events.ACTIVATE_FLY_OUT_BASKET, {});
			document.dispatchEvent(openFlyoutBasket);
		}
	}

	async function quickSampleAction(variant) {
		window.location.assign(`/api/quicksample/${variant.Language}/${variant.Code}`);
	}

	return { addSampleAction, quickSampleAction };
}
